import * as React from "react";
import styled, { css } from "styled-components";

const StyledScoreboardPanel = styled.div`
  padding: ${(props) => props.theme.space[2]} 0;
  background-color: ${({ theme }) => theme.colors.white};
  border: ${(props) => props.theme.borders[4]};
  border-radius: ${(props) => props.theme.radii[1]};
  text-align: center;
`;

const Heading = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${(props) => props.theme.fontSizes[3]};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
`;

const Value = styled.div<IValue>`
  font-size: 2.3rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primaryTwo};

  ${(props) =>
    props.isError &&
    css`
      color: ${props.theme.colors.error};
    `}

  ${(props) =>
    props.isSuccess &&
    css`
      color: ${props.theme.colors.success};
    `}
`;

interface IScoreboardPanel {
  heading: string;
  value: string;
}

interface IValue {
  isError?: boolean;
  isSuccess?: boolean;
}

type Props = IScoreboardPanel & IValue;

export const ScoreboardPanel: React.FC<Props> = ({
  heading,
  isError,
  isSuccess,
  value,
}) => (
  <StyledScoreboardPanel>
    <Heading>{heading}</Heading>
    <Value isError={isError} isSuccess={isSuccess}>
      {value}
    </Value>
  </StyledScoreboardPanel>
);
